import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteLegislationFromGroup = api(async function deleteLegislationFromGroup({
    projectId,
    groupId,
    legislationIds,
}) {
    return mutate(
        gql`
            mutation DeleteLegislationFromGroup($projectId: String!, $groupId: String!, $legislationIds: [Int!]!) {
                deleteLegislationFromGroup(projectId: $projectId, groupId: $groupId, legislationIds: $legislationIds)
            }
        `,
        { projectId, groupId, legislationIds },
        { returns: "deleteLegislationFromGroup" }
    )
})
